import config from '../config'
import VueAnalytics from 'vue-analytics'
import router from '../routes'

const isProd = process.env.NODE_ENV === 'production'

const analyticsConfig = {
  id: config.trackingID,
  router,
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
}

export { VueAnalytics as analytics, analyticsConfig }



// WEBPACK FOOTER //
// ./src/analytics/index.js